import { render, staticRenderFns } from "./TableTotalization.vue?vue&type=template&id=c996ce4a&scoped=true&"
import script from "./TableTotalization.vue?vue&type=script&lang=js&"
export * from "./TableTotalization.vue?vue&type=script&lang=js&"
import style0 from "./TableTotalization.vue?vue&type=style&index=0&id=c996ce4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c996ce4a",
  null
  
)

export default component.exports